module.exports = __webpack_public_path__ + "static/media/elements-agency-1.9916c76c.png";